import { render, staticRenderFns } from "./team-page-form.vue?vue&type=template&id=41f984d8&"
import script from "./team-page-form.vue?vue&type=script&lang=js&"
export * from "./team-page-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports